// appから商品ページに遷移してきたさいはrefer=appのパラメーターが付与されているので、
// その際はアプリでログイン情報が引き継げないため商品をカートに入れれないようにフォームを非表示にする
const hidePurchaceForm = () => {
  const productForm = document.getElementById("product-form");
  const url = new URL(window.location.href);
  const params = url.searchParams;
  const appParam = params.get("refer");

  if (!appParam) {
    return;
  }

  productForm.style.display = "none";
};

const target = document.getElementsByClassName(
  "product-form__cart-submit-box"
)[0];
const productQuantity = document.getElementsByClassName("product-quantity")[0];

if (target && productQuantity) {
  const viewHeight = document.documentElement.clientHeight;
  const rectLoad = target.getBoundingClientRect().height;
  const fixedBound = viewHeight - rectLoad;

  window.addEventListener("scroll", () => {
    const adjustPositon = 300;
    const scrollTop = document.documentElement.scrollTop - adjustPositon;
    if (scrollTop > fixedBound) {
      target.classList.add("is-fixed");
      productQuantity.classList.add("is-fixed");
    } else {
      target.classList.remove("is-fixed");
      productQuantity.classList.remove("is-fixed");
    }
  });
}

const cloneReviewRating = () => {
  const reviewRating = document.getElementsByClassName("star-ratings-css")[0];
  const reviewRatingText = document.getElementsByClassName(
    "mxpr-summary__count"
  )[0];
  const cloneReviewRating = reviewRating.cloneNode(true);
  const cloneReviewRatingText = reviewRatingText.cloneNode(true);
  const productReviewRating = document.getElementsByClassName(
    "product-review-rating-stars"
  )[0];
  const productReviewRatingText = document.getElementsByClassName(
    "product-review-rating-text"
  )[0];
  productReviewRating.appendChild(cloneReviewRating);
  productReviewRatingText.appendChild(cloneReviewRatingText);
};

$(function () {
  const p1 = $(".scroll-x").offset();

  $(window).on("scroll", function () {
    const scrollY = $(this).scrollTop();

    if (!p1) {
      return;
    }

    if (window.matchMedia("(min-width: 1080px)").matches) {
      $(".scroll-x").css({
        left: p1.left - scrollY / 4,
      });
    } else {
      $(".scroll-x").css({
        left: p1.left - scrollY / 3,
      });
    }
  });
});

hidePurchaceForm();
cloneReviewRating();
